<template>
  <div class="container">
    <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="formData.happinessCategoryTipsName"
            :label="'*' + $t('happinessTips.label.table.category')"
            :rules="categoryNameRules"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            :counter="50"
            :maxlength="50"
            class="linea-inferior-pura"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
          <v-select
            v-model="formData.status"
            :label="$t('tips.label.table.status')"
            :items="listStatus"
            item-text="nameStatus"
            item-value="valueStatus"
            :outlined="false"
            :filled="false"
            :solo="false"
            required
            class="linea-inferior-pura"
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12" md="12" class="text-center">
          <v-btn
            large
            rounded
            color="primary"
            dark
            type="submit"
          >
            {{ $t('button.save') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/utils/event_bus.js";
import i18n from '@/plugins/i18n';

import {
  HAPPINESS_TIPS_CATEGORIES_M,
  GET_HAPPINESS_TIPS_CATEGORIES,
  ACTION_POST_CREATE_HAPPINESS_TIPS_CATEGORIES,
} from "@/views/happiness-tips/categories-store/types/types.js";

export default {
  name: "FormAddHappinessTipsCategoriesComponent",
  data() {
    return {
      valid: false,
      formData: {
        happinessCategoryTipsName: "",
        status: true,
      },
      listStatus: [
        { idStatus: 1, nameStatus: 'Visible', valueStatus: true },
        { idStatus: 2, nameStatus: 'Oculto', valueStatus: false }
      ],
      categoryNameRules: [
        (v) => !!v || i18n.t('happinessTips.label.form.categoryNameRequired'),
        (v) => (v && v.trim().length >= 3) || i18n.t('happinessTips.label.form.categoryNameMinLength'),
        (v) => (v && v.length <= 50) || i18n.t('happinessTips.label.form.categoryNameMaxLength'),
        (v) => !this.categories.some(c => c.name && c.name.toLowerCase() === v.toLowerCase()) || i18n.t('tips.label.form.categoryNameDuplicate'),
      ],
    };
  },
  computed: {
    ...mapGetters({
      categories: `${HAPPINESS_TIPS_CATEGORIES_M}${GET_HAPPINESS_TIPS_CATEGORIES}`,
    }),
  },
  methods: {
    ...mapActions({
      postActionCategories: `${HAPPINESS_TIPS_CATEGORIES_M}${ACTION_POST_CREATE_HAPPINESS_TIPS_CATEGORIES}`,
    }),

    async submitForm() {
      if (this.$refs.form.validate()) {
        try {
          this.formData.happinessCategoryTipsName = this.formData.happinessCategoryTipsName.trim();

          await this.postActionCategories(this.formData);
          EventBus.$emit('formHappinessTipsCategories-submitted-successfully');

          this.formData.happinessCategoryTipsName = "";
          this.formData.status = true;

          this.$refs.form.resetValidation();
        } catch (error) {
          console.error("Error al crear categoría:", error);
        }
      }
    },
    resetForm() {
      if (this.$refs.form) {
        this.formData.happinessCategoryTipsName = "";
        this.formData.status = true;
        this.$refs.form.resetValidation();
      }
    }
  },
  mounted() {
    EventBus.$on('clear-happiness-tips-categories-form', this.resetForm);
  },
  beforeDestroy() {
    EventBus.$off('clear-happiness-tips-categories-form', this.resetForm);
  }
};
</script>

<style lang="css" scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.linea-inferior-pura ::v-deep fieldset {
  display: none !important;
  border: none !important;
}

.linea-inferior-pura ::v-deep .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0px !important;
}

.linea-inferior-pura.v-input--is-focused ::v-deep .v-input__slot {
  border-bottom: 2px solid #6e17a5 !important;
}
</style>